import * as PIXI from "pixi.js";
import { Spine } from "@pixi/spine-pixi";
import { GameAssets } from "src/shared/util/GameAssets";

// Create a SymbolPool class to manage the pool of symbols
class PaylinePool {
  private pool: Payline[] = [];

  constructor(initialPoolSize: number = 10) {
    for (let i = 0; i < initialPoolSize; i++) {
      this.pool.push(new Payline(1));
    }
  }

  public acquire(index: number): Payline {
    if (this.pool.length > 0) {
      const payline = this.pool.pop()!;
      payline.setIndex(index);
      return payline;
    } else {
      return new Payline(index);
    }
  }

  public release(symbol: Payline) {
    symbol.parent?.removeChild(symbol);
    this.pool.push(symbol);
  }
}

export class Payline extends PIXI.Container {
  private static _pool: PaylinePool;

  public static get pool(): PaylinePool {
    if (!Payline._pool) {
      throw new Error(
        "Symbol pool is not initialized. Call Symbol.createPool() first.",
      );
    }
    return Payline._pool;
  }

  public static createPool(initialPoolSize: number = 10) {
    Payline._pool = new PaylinePool(initialPoolSize);
  }

  private skeleton: Spine;

  constructor(index: number) {
    super();

    this.skeleton = Spine.from({
      skeleton: "paylinesJson", // String key that PIXI will look up
      atlas: "paylinesAtlas", // String key that PIXI will look up
    });

    this.skeleton.state.addListener({
      complete: (entry) => {
        this.removeChild(this.skeleton);
      },
    });

    this.skeleton.state.setAnimation(0, `Payline${index}`, false);
    this.addChild(this.skeleton);
  }

  public setIndex(index: number) {
    this.skeleton.state.setAnimation(0, `Payline${index}`, false);
    this.addChild(this.skeleton);
  }
}
